export const CheckLeadership=()=>{
    let user_type=sessionStorage.getItem('UserType')
    if(user_type==='leadership'||(user_type!=='tm'&&user_type!=='rm'&&user_type!=='sh'&&user_type!=='ds'&&user_type!=='mds'&&user_type!=='ft')){
        return true;
    }
    else{
        return false;
    }
}